// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"7975b945","513":"925beb79","703":"1fe5cc42","787":"5a69c3a5"}[chunkId] + ".chunk.js";
};